// @ts-check
import React from "react";

/** @typedef {{} & React.SVGAttributes } DistanceIconProps */

/* eslint-disable max-len */
/** @type { React.FC<DistanceIconProps> } */
export const DistanceIcon = props => {
  return (
    <svg {...props} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">
      <path
        d="M82 0c7.7 0 14 6 14 14a23 23 0 01-1.1 6.5L82 48 69.1 20.5c-.6-1.6-1.1-4.6-1.1-6.5 0-8 6.2-14 14-14zm0 8a6 6 0 100 12 6 6 0 000-12zM16 42c8.9 0 16 6.9 16 16 0 2-.6 5.2-1.3 7L16 96 1.3 65C.6 63.3 0 60 0 58c0-9.1 7.2-16 16-16zm62.1 9a2 2 0 011 3.6l-54 40a2 2 0 11-2.3-3.2l54-40a2 2 0 011.3-.4zM16 51a7 7 0 100 14 7 7 0 000-14z"
        fill="currentColor"
      />
    </svg>
  );
};
/* eslint-enable max-len */
